import React from 'react';

interface StatusBadgeProps {
  status: string;
}

const statusStyles: Record<string, string> = {
  Completed: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
  Success: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
  Failed: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300',
  Running: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300',
  PartialFailure: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300',
  Skipped: 'bg-surface-hover text-muted',
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const style = statusStyles[status] || 'bg-surface-hover text-primary';
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${style}`}>
      {status}
    </span>
  );
};
